import React, { useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import images from "../../images";
import { cn } from "../../Utils/helper";

const PhoneInputProps = React.memo(
  ({ value, onChange, readOnly = false, className }) => {
    const { t } = useTranslation();
    const inputRef = useRef(null);
    const formatPhoneNumber = (phone) => {
      const cleaned = phone.replace(/[^0-9]/g, "");
      const formatted =
        cleaned.length > 4
          ? `${cleaned.slice(0, 4)}-${cleaned.slice(4, 8)}`
          : cleaned;
      return formatted;
    };
    const handleInputChange = useCallback(
      (e) => {
        const formattedPhone = formatPhoneNumber(e.target.value);
        onChange(formattedPhone);
      },
      [onChange]
    );
    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, [value]);

    return (
      <div
        className={cn(
          "flex items-center bg-white rounded-lg px-3 py-2 border border-gray-300",
          className
        )}
      >
        <div className="flex gap-[6px]  h-full items-center border-r pr-1">
          <div className="w-6">
            <img
              src={images.WhatsappIconWhite}
              alt="Whatsapp Icon"
              className="h-6 w-6 object-contain"
            />
          </div>
          <div className=" text-[#A0A0A0] font-medium text-sm">+65</div>
          <div className="">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-3 w-3 text-[#A0A0A0]"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>

        {/* Đầu số */}

        {/* Input */}
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={handleInputChange}
          className="outline-none w-full bg-transparent text-[#333333] ml-2"
          placeholder={t("signUp.whatsAppNumber")}
          readOnly={readOnly}
        />
      </div>
    );
  }
);

export default PhoneInputProps;
